<div
  class="container"
  fxLayout="row wrap"
  fxLayoutGap="2%"
  fxLayout.lt-md="column"
  matomoForm="incoming-transaction-export"
>
  <form
    #postForm="ngForm"
    (ngSubmit)="exportCSV(postForm.value)"
    class="csv-form"
  >
    <div
      class="container-fluid"
      fxLayout="row wrap"
      fxLayoutGap="5%"
      fxLayout.lt-md="column"
    >
      <mat-form-field>
        <mat-label>{{ "TRANSACTIONS.TRANSACTION_ID" | translate }}</mat-label>
        <textarea
          matInput
          class="form-control col-sm-4"
          ngModel
          name="transactionid"
          placeholder="{{ 'EXPORT.COMMA_SEPARATED_LIST' | translate }}"
          id="transactionid"
          matomoClick="export-filter-transaction-id"
          (focus)="onFilterUsed('Transaction ID')"
          (blur)="onFilterUsed('Transaction ID', $event.target.value)"
          rows="3"
        ></textarea>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "EXPORT.WORKFLOW_INSTANCE_KEY" | translate }}</mat-label>
        <textarea
          matInput
          class="form-control col-sm-4"
          ngModel
          name="workflowinstancekey"
          placeholder="{{ 'EXPORT.COMMA_SEPARATED_LIST' | translate }}"
          id="workflowinstancekey"
          matomoClick="export-filter-workflow-key"
          (focus)="onFilterUsed('Workflow Instance Key')"
          (blur)="onFilterUsed('Workflow Instance Key', $event.target.value)"
          rows="3"
        ></textarea>
      </mat-form-field>
      <mat-form-field
        (click)="startDatePicker.open(); onDatePickerUsed('start')"
      >
        <mat-label>{{ "EXPORT.START_DATE" | translate }}</mat-label>
        <input
          matInput
          type="text"
          class="form-control col-sm-4"
          ngModel
          name="startdate"
          placeholder="{{ 'EXPORT.START_DATE' | translate }}"
          id="startdate"
          [matDatepicker]="startDatePicker"
          matomoClick="export-filter-start-date"
          (focus)="onFilterUsed('Start Date')"
          (dateChange)="onFilterUsed('Start Date', $event.value)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="startDatePicker"
          matomoClick="export-datepicker-start-toggle"
        ></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field (click)="endDatePicker.open(); onDatePickerUsed('end')">
        <mat-label>{{ "EXPORT.END_DATE" | translate }}</mat-label>
        <input
          matInput
          type="text"
          class="form-control col-sm-4"
          ngModel
          name="enddate"
          placeholder="{{ 'EXPORT.END_DATE' | translate }}"
          id="enddate"
          [matDatepicker]="endDatePicker"
          matomoClick="export-filter-end-date"
          (focus)="onFilterUsed('End Date')"
          (dateChange)="onFilterUsed('End Date', $event.value)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="endDatePicker"
          matomoClick="export-datepicker-end-toggle"
        ></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label for="querytype" class="form-control">{{
          "EXPORT.FILTER_BY" | translate
        }}</mat-label>
        <select
          id="querytype"
          name="status"
          class="form-control col-sm-4"
          ngModel
          matNativeControl
          matomoClick="export-filter-status"
          (focus)="onFilterUsed('Status')"
          (change)="onFilterUsed('Status', $event.target.value)"
        >
          <option value="" matomoClick="export-status-option-all">
            {{ "COMMON.STATUS" | translate }}
          </option>
          <option
            value="COMPLETED"
            matomoClick="export-status-option-completed"
          >
            {{ "COMMON.COMPLETED" | translate }}
          </option>
          <option value="FAILED" matomoClick="export-status-option-failed">
            {{ "COMMON.FAILED" | translate }}
          </option>
          <option
            value="IN_PROGRESS"
            matomoClick="export-status-option-in-progress"
          >
            {{ "COMMON.IN_PROGRESS" | translate }}
          </option>
        </select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "TRANSACTIONS.PAYER_ID" | translate }}</mat-label>
        <textarea
          matInput
          class="form-control col-sm-4"
          ngModel
          name="payerid"
          placeholder="{{ 'EXPORT.COMMA_SEPARATED_LIST' | translate }}"
          id="payerid"
          matomoClick="export-filter-payer-id"
          (focus)="onFilterUsed('Payer ID')"
          (blur)="onFilterUsed('Payer ID', $event.target.value)"
          rows="3"
        ></textarea>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "TRANSACTIONS.PAYEE_ID" | translate }}</mat-label>
        <textarea
          matInput
          class="form-control col-sm-4"
          ngModel
          name="payeeid"
          placeholder="{{ 'EXPORT.COMMA_SEPARATED_LIST' | translate }}"
          id="payeeid"
          matomoClick="export-filter-payee-id"
          (focus)="onFilterUsed('Payee ID')"
          (blur)="onFilterUsed('Payee ID', $event.target.value)"
          rows="3"
        ></textarea>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{
          "TRANSACTIONS.AMS_BUSINESS_SHORT_CODE" | translate
        }}</mat-label>
        <mat-select
          class="form-control col-sm-4"
          ngModel
          name="payerdfspid"
          placeholder="{{ 'EXPORT.COMMA_SEPARATED_LIST' | translate }}"
          id="payerdfspid"
          multiple
          matomoClick="export-filter-ams-code"
          (focus)="onFilterUsed('AMS Business Code')"
          (selectionChange)="
            onAmsCodeSelection($event.value);
            onFilterUsed('AMS Business Code', $event.value)
          "
        >
          <mat-option
            *ngFor="let code of amsCodes"
            [value]="code.value"
            matomoClick="export-ams-code-option-{{ code.value }}"
          >
            {{ code.option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <button
      mat-stroked-button
      type="submit"
      [disabled]="!postForm.valid"
      matomoClick="export-csv-submit-button"
      (click)="onFormValidationChange(postForm.valid)"
    >
      {{ "EXPORT.EXPORT_CSV" | translate }}
    </button>
  </form>
</div>

